import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import principle03 from "./layouts/principle-03/principle";
import principle04 from "./layouts/principle-04/principle";
import principle05 from "./layouts/principle-05/principle";

const lesson: Lesson = {
  id: "b946b8b1-9dcc-4693-9d52-adca64cc99c8",
  publicId: "31",
  name: "Room acoustics",
  difficulty: 2,
  showHeaderNavigation: true,
  body: [principle01, principle02, principle03, principle04, principle05],
};

export default lesson;
